import React, { useState } from 'react';

export function FAQ() {
  const [openItem, setOpenItem] = useState(0);

  const faqs = [
    {
      question: "How will the GitHub integration work with different AI tools?",
      answer: "Our audit will work with any GitHub repository, regardless of how your code was generated. Whether you used Lovable, Cursor, v0, Bolt, Claude, or any other AI coding tool, you'll simply connect your GitHub repo with one click. Our AI will analyze the actual code structure, dependencies, and current integrations to identify growth opportunities specific to your tech stack."
    },
    {
      question: "What exactly will I get in the $19 audit report?",
      answer: "You'll receive a comprehensive report that identifies missing growth features like analytics tracking (PostHog, GA), customer support setup (Intercom, help docs), email capture (newsletter, waitlist), marketing pixels (Meta, TikTok), and conversion tracking. The report will include prioritized recommendations, specific implementation steps, code examples, and detailed guides tailored to your existing codebase and tech stack."
    },
    {
      question: "How quickly will I receive my audit report when you launch?",
      answer: "Your complete audit report will be delivered in approximately 2 minutes after connecting your GitHub repository. The AI will perform an automated analysis of your entire codebase and generate a detailed report with actionable recommendations and implementation steps."
    },
    {
      question: "What if my app is still in development or has no users yet?",
      answer: "That's actually perfect timing! Getting an audit early will help you build growth features from the start rather than retrofitting them later. The report will identify which growth essentials to implement during development, saving you time and ensuring your app is ready to acquire users from day one."
    },
    {
      question: "Will you support private GitHub repositories?",
      answer: "Yes, we'll support both public and private GitHub repositories. Your code will remain secure and private - we'll only analyze the structure and existing integrations to generate your growth audit report. We'll never store or share your actual code."
    },
    {
      question: "What if I don't know how to implement the recommendations?",
      answer: "Every audit report will include step-by-step implementation guides with specific code examples and instructions. Whether you're using an AI coding tool or coding manually, the recommendations will include detailed technical guidance to help you implement each suggested feature."
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
            Frequently asked questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our coming app growth audit
          </p>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
              <button
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => setOpenItem(openItem === index ? -1 : index)}
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <svg
                  className={`w-6 h-6 text-gray-500 transform transition-transform ${
                    openItem === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {openItem === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Ready to be first in line for our app growth audit tool?
          </p>
          <button className="bg-orange-600 text-white font-bold px-8 py-3 rounded-full hover:bg-orange-700 transition-colors cursor-pointer">
            Join Waitlist - Early Bird $19
          </button>
        </div>
      </div>
    </section>
  );
}